/*
 * 2016 sitegeist media solutions GmbH
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of sitegeist media solutions GmbH and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to sitegeist media solutions GmbH
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from sitegeist media solutions GmbH.
 *
 */

/** @jsx h */

import {h, render, Component} from 'preact';
import mergeClassnames from 'classnames';

export default class Frame extends Component {
	state = {
		width: 5000,
		height: 5000,
		isLoading: true
	};

	componentWillReceiveProps(nextProps) {
		if (nextProps.image != this.props.image) {
			this.setState({isLoading: true});
		}
	}

	componentDidMount() {
		this.setState({
			width: this.base.clientWidth,
			height: this.base.clientHeight
		});

		this.__boundResize = this.onResize.bind(this);
		window.addEventListener('resize', this.__boundResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.__boundResize);
	}

	onLoad() {
		this.setState({
			width: this.__image.clientWidth,
			height: this.__image.clientHeight
		});

		setTimeout(() => this.setState({isLoading: false}), 500);
	}

	onResize() {
		setTimeout(() => this.setState({
			width: this.__image.clientWidth,
			height: this.__image.clientHeight
		}), 0);
	}

	render({image, description}) {
		const {isLoading, width, height} = this.state;
		const loader = (<div
							className="lightbox__gallery__frame__loader__container">
							<div className="lightbox__gallery__frame__loader" />
						</div>);

		const imageClassNames = mergeClassnames({
			'lightbox__gallery__frame__image': true,
			'lightbox__gallery__frame__image--isLoading': isLoading
		});

		return (<div className="lightbox__gallery__frame" style={{width, height}}>
			{<img
				src={image}
				alt={description}
				className={imageClassNames}
				ref={img => this.__image = img}
				onLoad={() => this.onLoad()}
				/>}
			{isLoading && loader}
		</div>);
	}
}
